import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import {Election} from "../Election";
import {getMessage} from "../util";
import {ObjectMap} from "../ObjectMap";

export type PrivateProps = {
    messages: null | ObjectMap<string>,
    election: Election
}

const Private = (props:PrivateProps) => {
    return(
        <Row className={"justify-content-center"}>
            <Col xs={12} sm={11} md={9} lg={7} className={"text-center"}>
                <p className={"lead"}>{getMessage('private_response', props.messages)}</p>
                <Button className="EvColorGrisLight m-1"
                        href={props.election.configuration.home_url}
                        variant="light">{getMessage('exit_button', props.messages)}</Button>
            </Col>
        </Row>
    )
}

export default Private;